export const LANGS = {
  en: 'english',
  'pt-BR': 'português',
};

export const API_REGISTER = 'https://rt8oym2r5f.execute-api.sa-east-1.amazonaws.com/dev/register';

export const API_LOGIN = 'https://rt8oym2r5f.execute-api.sa-east-1.amazonaws.com/dev/register/login';
// export const API_LOGIN = 'https://api.milkway.link/dev/register/login';

export const API_UPDATE_LAST_STATION = 'https://rt8oym2r5f.execute-api.sa-east-1.amazonaws.com/dev/register/entry-point';
export const API_UPDATE_ROUTE = 'https://rt8oym2r5f.execute-api.sa-east-1.amazonaws.com/dev/register/route-destiny';
export const STATION_ID_DEFAULT = 'earth.station';
export const STATION_NAME_DEFAULT = 'Earth';
export const LOCALSTORAGE_ANONYMOUS_LAST_STATION = 'anonymousLastStation';
export const LOCALSTORAGE_ANONYMOUS_ROUTE = 'anonymousRoute';
